import { ThunkResult } from '../../../../store/configureStore'
import { MemberGateway } from '../../../gateways/memberGateway.interface'
import { Actions } from '../actionCreators'
import {
  FileType
} from '../../../../adapters/primary/view-model-generators/documents/available-files-generators/availableFilesViewModelGenerator'
import { getCurrentUser } from '../../../../store/reducers/currentUser.reducer'

export const createNewMember: (email: string, rights: Array<FileType>) => ThunkResult<Promise<void>> =
  (email: string, rights: Array<FileType>) => async (dispatch, getState,
    { memberGateway }: { memberGateway: MemberGateway }) => {
    const currentUser = getCurrentUser(getState())
    const member = await memberGateway.create(email, rights, currentUser.uuid)
    dispatch(Actions.memberCreated(member))
  }
